export var DEPLOY_DATE = new Date('2026-04-07T11:47:09+0000');
